import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "handle"]

  connect() {
    // Calculate min height based on rows attribute if present, otherwise default to 120px
    const rows = this.inputTarget.getAttribute('rows')
    if (rows) {
      // Approximate calculation: each row is about 24px (line-height of 1.5 * 16px font)
      // Plus padding (py-3 = 12px top + 12px bottom = 24px)
      const lineHeight = 24
      const padding = 24
      this.minHeight = (parseInt(rows) * lineHeight) + padding
    } else {
      this.minHeight = 120 // min-h-[120px] = 4 rows approximately
    }
    this.isResizing = false
    this.resize()
  }

  resize() {
    // Skip auto-resize if user has manually resized
    if (this.manualHeight) return

    const textarea = this.inputTarget

    // Reset to min height first to allow shrinking
    textarea.style.height = `${this.minHeight}px`

    // If content is larger than min height, expand
    if (textarea.scrollHeight > this.minHeight) {
      textarea.style.height = `${textarea.scrollHeight}px`
    }
  }

  startResize(event) {
    event.preventDefault()
    this.isResizing = true
    this.startY = event.clientY || event.touches?.[0]?.clientY
    this.startHeight = this.inputTarget.offsetHeight

    // Add event listeners for drag
    document.addEventListener("mousemove", this.doResize)
    document.addEventListener("mouseup", this.stopResize)
    document.addEventListener("touchmove", this.doResize)
    document.addEventListener("touchend", this.stopResize)

    // Prevent text selection during drag
    document.body.style.userSelect = "none"
    document.body.style.cursor = "ns-resize"
  }

  doResize = (event) => {
    if (!this.isResizing) return

    const clientY = event.clientY || event.touches?.[0]?.clientY
    const deltaY = clientY - this.startY
    const newHeight = Math.max(this.minHeight, this.startHeight + deltaY)

    this.inputTarget.style.height = `${newHeight}px`
    this.manualHeight = newHeight
  }

  stopResize = () => {
    this.isResizing = false

    // Remove event listeners
    document.removeEventListener("mousemove", this.doResize)
    document.removeEventListener("mouseup", this.stopResize)
    document.removeEventListener("touchmove", this.doResize)
    document.removeEventListener("touchend", this.stopResize)

    // Restore default cursor and selection
    document.body.style.userSelect = ""
    document.body.style.cursor = ""
  }

  // Reset manual height when content changes significantly
  resetManualHeight() {
    this.manualHeight = null
    this.resize()
  }
}
